import * as actionTypes from "../../actions/campaigns/actionTypes";
import { updateObject } from "../../utility/utility";

const initialState = {
  error: null,
  campaigns: [],
  totalReservations: [],
  campaignDetails: [],
  investors: [],
  documents: [],
  investor: [],
  secondaryMarketInvestor: [],
  activities: [],
  repaymentIn: [],
  distribution: [],
  distributionDetail: [],
  isLoading: false,
  loading: true,
  updatedCampaigns: [],
  campaignShareCertificates: [],
  achPaymentConfirmToken: null,
  achPaymentConfirmationId: null,
  generateShareCertificate: null,
};

const campaignStart = (state, action) => {
  return updateObject(state, {
    error: null,
    totalReservations: [],
    documents: [],
    investor: [],
    secondaryMarketInvestor: [],
    updatedCampaigns: [],
    achPaymentConfirmToken: null,
    achPaymentConfirmationId: null,
    generateShareCertificate: null,
    campaignShareCertificates: [],
  });
};

const campaignFail = (state, action) => {
  return updateObject(state, {
    error: action.error,
  });
};

const getCampaigns = (state, action) => {
  return updateObject(state, {
    campaigns: action.response,
  });
};

export const getTotalReservations = (state, action) => {
  return updateObject(state, {
    totalReservations: action.response,
  });
};

export const getCampaignDetails = (state, action) => {
  return updateObject(state, {
    campaignDetails: action.response,
  });
};

export const getInvestors = (state, action) => {
  return updateObject(state, {
    investors: action.response,
  });
};

export const getSecondaryMarketInvestors = (state, action) => {
  return updateObject(state, {
    secondaryMarketInvestor: action.response,
  });
};

export const getDocuments = (state, action) => {
  return updateObject(state, {
    documents: action.response,
  });
};

export const getInvestor = (state, action) => {
  return updateObject(state, {
    investor: action.response,
  });
};

export const getCampaignActivities = (state, action) => {
  return updateObject(state, {
    activities: action.response,
  });
};

export const getRePaymentIn = (state, action) => {
  return updateObject(state, {
    repaymentIn: action.response,
  });
};

export const getDistribution = (state, action) => {
  return updateObject(state, {
    distribution: action.response,
  });
};

export const getDistributionDetail = (state, action) => {
  return updateObject(state, {
    distributionDetail: action.response,
    distributionData: action.response.distributionData,
    isLoading: false,
  });
};

export const isLoading = (state, action) => {
  return updateObject(state, {
    loading: action.response,
  });
};

export const updateCampaigns = (state, action) => {
  return updateObject(state, {
    updateCampaigns: action.response,
  });
};

const clearStripeACHPaymentToken = (state, action) => {
  return updateObject(state, {
    achPaymentConfirmToken: null,
  });
};

const getStripeACHPaymentTokenSuccess = (state, action) => {
  return updateObject(state, {
    achPaymentConfirmToken: action.response,
  });
};

const postStripeACHPaymentConfimationSuccess = (state, action) => {
  return updateObject(state, {
    achPaymentConfirmationId: action.response,
  });
};

const clearStripeACHPaymentConfimation = (state, action) => {
  return updateObject(state, {
    achPaymentConfirmationId: null,
  });
};

const generateCampaignShareCertificate = (state, action) => {
  return updateObject(state, {
    generateShareCertificate: action.response,
  });
};

const campaignShareCertificateList = (state, action) => {
  return updateObject(state, {
    campaignShareCertificates: action.response,
  });
};

const clearOneTimeError = (state, action) => {
  return updateObject(state, {
    error: null,
  });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.CAMPAIGN_START:
      return campaignStart(state, action);
    case actionTypes.CAMPAIGN_FAIL:
      return campaignFail(state, action);
    case actionTypes.GET_CAMPAIGNS_SUCCESS:
      return getCampaigns(state, action);
    case actionTypes.GET_TOTAL_RESERVARTIONS_SUCCESS:
      return getTotalReservations(state, action);
    case actionTypes.GET_CAMPAIGN_DETAILS_SUCCESS:
      return getCampaignDetails(state, action);
    case actionTypes.GET_INVESTORS_SUCCESS:
      return getInvestors(state, action);
    case actionTypes.GET_SECONDARY_MARKET_INVESTORS_SUCCESS:
      return getSecondaryMarketInvestors(state, action);
    case actionTypes.GET_DOCUMENTS_SUCCESS:
      return getDocuments(state, action);
    case actionTypes.GET_INVESTOR_DETAILS_SUCCESS:
      return getInvestor(state, action);
    case actionTypes.GET_CAMPAIGN_ACTIVITIES_SUCCESS:
      return getCampaignActivities(state, action);
    case actionTypes.GET_REPAYMENT_IN_SUCCESS:
      return getRePaymentIn(state, action);
    case actionTypes.GET_DISTRIBUTION_SUCCESS:
      return getDistribution(state, action);
    case actionTypes.GET_DISTRIBUTION_DETAIL_SUCCESS:
      return getDistributionDetail(state, action);
    case actionTypes.UPDATE_CAMPAIGN_SUCCESS:
      return updateCampaigns(state, action);
    case actionTypes.IS_LOADING:
      return isLoading(state, action);
    case actionTypes.GET_STRIPE_ACH_PAYMENT_TOKEN_SUCCESS:
      return getStripeACHPaymentTokenSuccess(state, action);
    case actionTypes.CLEAR_STRIPE_ACH_PAYMENT_TOKEN:
      return clearStripeACHPaymentToken(state, action);
    case actionTypes.POST_STRIPE_ACH_PAYMENT_CONFIMATION_SUCCESS:
      return postStripeACHPaymentConfimationSuccess(state, action);
    case actionTypes.CLEAR_STRIPE_ACH_PAYMENT_CONFIMATION:
      return clearStripeACHPaymentConfimation(state, action);
    case actionTypes.GENERATE_CAMPAIGN_SHARE_CERTIFICATE_SUCCESS:
      return generateCampaignShareCertificate(state, action);
    case actionTypes.CAMPAIGN_SHARE_CERTIFICATE_LIST_SUCCESS:
      return campaignShareCertificateList(state, action);
    case actionTypes.CLEAR_ONE_TIME_ERROR:
      return clearOneTimeError(state, action);
    default:
      return state;
  }
};

export default reducer;
